var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.0625 0 10 0.9375 10 2V4H18V2C18 0.9375 18.875 0 20 0C21.0625 0 22 0.9375 22 2V4H25C26.625 4 28 5.375 28 7V10H0V7C0 5.375 1.3125 4 3 4H6V2C6 0.9375 6.875 0 8 0ZM0 12H28V29C28 30.6875 26.625 32 25 32H3C1.3125 32 0 30.6875 0 29V12ZM14.5625 15.6875C14.3125 15.25 13.625 15.25 13.375 15.6875L11.9375 18.6875L8.625 19.1875C8.0625 19.25 7.875 19.9375 8.25 20.3125L10.625 22.625L10.0625 25.875C10 26.4375 10.5625 26.8125 11 26.5625L14 25L16.9375 26.5625C17.375 26.8125 17.9375 26.4375 17.875 25.875L17.3125 22.625L19.6875 20.3125C20.0625 19.9375 19.875 19.25 19.3125 19.1875L16.0625 18.6875L14.5625 15.6875Z",
    fill: "#A63F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarStar);
export default __webpack_public_path__ + "static/media/calendar-star.c2e4910c68ec92ba95f3548cbcbf14fd.svg";
export { ForwardRef as ReactComponent };